import NotificationManager from "../../utils/class/notifications";

export default class JobSharing {
    constructor () {
        const copyLink = document.querySelector('#copy-link');
        if (!copyLink) return;

        this.copyLink = copyLink;

        this.NotificationManager = new NotificationManager();

        this.init();
    }

    init () {
        this.copyLink.addEventListener('click', (event) => {
            event.stopPropagation();

            try {
                navigator.clipboard.writeText(window.location.href)
                    .then(() => {
                        this.NotificationManager.sendNotification('success', 'Job link copied!', 'The link has been successfully copied to clipboard.');
                    })
                    .catch(() => {
                        this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
                    });
            } catch (error) {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
            }
        });
    }
}